export const VIP = {
	memberPage: 'member-vip-page',
	programCard: 'vip-program-card',
	applyForm: 'vip-apply-form',
	applySubmit: 'vip-apply-submit',
	applicationRow: 'vip-application-row',
	groupCard: 'vip-group-card',
	groupWhatsapp: 'vip-group-whatsapp',
	groupTelegram: 'vip-group-telegram',
	groupTiktok: 'vip-group-tiktok',
	groupDiscord: 'vip-group-discord',
	adminPage: 'admin-vip-page',
	adminProgramNew: 'admin-vip-program-new',
	adminProgramSave: 'admin-vip-program-save',
	adminAppRow: 'admin-vip-app-row',
	reviewApprove: 'vip-review-approve',
	reviewReject: 'vip-review-reject',
	reviewReview: 'vip-review-review',
	reviewSubmit: 'vip-review-submit',
};
